import "@babel/polyfill";
import "isomorphic-fetch";
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "react-redux";
import store, { i18nConfig } from "./store";
import MyResultsApp from "./Core/MyResultsApp";
import { addLocaleData, IntlProvider } from "react-intl";
import loadPolyfills from "./asyncPolyfills";
import history from "./appHistory";
import { Router } from "react-router";
import { IsMobileProvider } from "./isMobileContext";

loadPolyfills(() => {
  const localeData = [
    require("react-intl/locale-data/en"),
    require("react-intl/locale-data/es"),
    require("react-intl/locale-data/nl"),
    require("react-intl/locale-data/pl"),
    require("react-intl/locale-data/no"),
    require("react-intl/locale-data/it"),
    require("react-intl/locale-data/fr"),
    require("react-intl/locale-data/pt"),
    require("react-intl/locale-data/de"),
    require("react-intl/locale-data/ru"),
    require("react-intl/locale-data/no"),
    require("react-intl/locale-data/cs"),
    require("react-intl/locale-data/sk"),
    require("react-intl/locale-data/da"),
  ];

  localeData.forEach((locale) => addLocaleData(locale));

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider locale={i18nConfig.locale} messages={i18nConfig.messages}>
        <Router history={history}>
          <IsMobileProvider>
            <MyResultsApp />
          </IsMobileProvider>
        </Router>
      </IntlProvider>
    </Provider>,
    document.getElementById("root")
  );
});
